import React, { useEffect } from 'react';

import WizardContext from './wizardContext';

interface StepsProps {
  children: React.ReactNode;
}

const Steps: React.FC<StepsProps> = ({ children }) => {
  const context = React.useContext(WizardContext);

  useEffect(() => {
    context?.setSteps(children);
  }, [context, children]);

  return null;
};

export default Steps;
